// Legal policies are DDD-wide: Profound Philosophy links to the central
// Dive Deep Dialogues versions rather than keeping its own copies (the fleet
// pattern; see apps/art-of-conversation/src/config/legalLinks.js). The in-app
// /privacy page is only this app's data details and privacy settings.
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const DDD_TERMS_URL = 'https://divedeepdialogues.com/terms';
export const DDD_PRIVACY_URL = 'https://divedeepdialogues.com/privacy';
export const DDD_COOKIES_URL = 'https://divedeepdialogues.com/cookies';

// Opens a central policy page. Inside the iOS app it opens in the in-app
// browser sheet, so the app's own web view never navigates away; on the web
// it opens in a new tab.
export const openLegalPage = (url) => {
  if (Capacitor.isNativePlatform()) {
    Browser.open({ url }).catch(() => { window.open(url, '_blank', 'noopener'); });
  } else {
    window.open(url, '_blank', 'noopener');
  }
};
